<main #mainElement class="w-full">
	<lbca-input-text-condensed
		[maskInput]="'DATE_BR'"
		[tabeled]="isTabeled"
		[labeled]="!isLabeled"
		[disabled]="isDisabled"
		[require]="isRequired"
		[helperText]="helperTextValue"
		[label]="labelValue"
		(focusState)="setFocus($event)"
		[componetIconStyle]="componetIconStyle"
		(changeValue)="change($event)"
		(click)="click()"
		[hasExternalError]="hasError"
		[value]="valueInput"
	></lbca-input-text-condensed>
</main>

<ng-template cdkPortal #templateAppend="cdkPortal">
	@if (!isLabeled && !isTabeled) {
		<div
			(mousedown)="eventBlockFocusOut($event)"
			class="datepicker-template-condensed"
			[ngClass]="helperTextValue && helperTextValue !== '' ? 'mt-[18px]' : 'mt-[12px]'"
		>
			<div class="dpt-arrow"></div>
			<section class="dpt-header">
				<div class="dpt-base-date">
					<div (click)="changeTypeSelection()" class="dpt-base-date-button">
						{{ typeSelection === 'calendar' ? baseDate : baseYear }}
						<span class="dpt-ico-helper-base-date"></span>
					</div>
				</div>
				<div class="dpt-base-butons">
					<button (click)="changeMonth('previus')" class="dpt-btn-box">
						<span class="dpt-btn-previus"></span>
					</button>
					<button (click)="changeMonth('next')" class="dpt-btn-box">
						<span class="dpt-btn-next"></span>
					</button>
				</div>
			</section>
			@if (typeSelection === 'calendar') {
				<section class="dpt-calendar">
					<div class="dpt-week-labels">
						@for (weekDay of weekDays; track weekDay) {
							<div
								class="dpt-week-day"
								[class.dpt-week-zone-header]="getDayMathSelect(weekDay.index)"
							>
								{{ weekDay.label }}
							</div>
						}
					</div>
					<div class="dpt-week-struct">
						@for (week of calendar; track week) {
							<div class="dpt-week-row">
								@for (day of week.days; track day) {
									<div
										[class.dpt-week-zone]="getDayMathSelect(day)"
										(mouseenter)="weekSelect = day"
										(mouseleave)="weekSelect = null"
										class="dpt-day-round"
										(click)="selectDay(day)"
									>
										<div [class]="day.month() === baseMonth ? 'dpt-day' : 'dpt-day-month'">
											{{ day.format('DD') }}
										</div>
									</div>
								}
							</div>
						}
					</div>
				</section>
			}
			@if (typeSelection === 'month') {
				<section class="dpt-month-table">
					@for (month of yearMonths; track month) {
						<div class="dpt-month-cell">
							<div (click)="selectMonth(month.index)" class="dpt-month-cell-button">
								{{ month.label }}
							</div>
						</div>
					}
				</section>
			}
		</div>
	}
</ng-template>
